import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Character } from '../api/characters';

interface CharacterContextType {
  selectedCharacter: Character | null;
  setSelectedCharacter: (character: Character | null) => void;
}

const CharacterContext = createContext<CharacterContextType | undefined>(undefined);

interface CharacterProviderProps {
  children: ReactNode;
}

/**
 * Provider component for character context
 * Makes the selected character available throughout the application
 */
export const CharacterProvider: React.FC<CharacterProviderProps> = ({ children }) => {
  const [selectedCharacter, setSelectedCharacter] = useState<Character | null>(null);
  
  return (
    <CharacterContext.Provider value={{ selectedCharacter, setSelectedCharacter }}>
      {children}
    </CharacterContext.Provider>
  );
};

/**
 * Hook for consuming the character context
 * Returns the selected character and setter function
 */
export const useCharacterContext = (): CharacterContextType => {
  const context = useContext(CharacterContext);
  
  if (context === undefined) {
    throw new Error('useCharacterContext must be used within a CharacterProvider');
  }
  
  return context;
}; 